// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1kwUo","label":"Completed_label__hVr9q"};